module.exports = __webpack_public_path__ + "static/Slide-03-947f5644f92da988ccd645d11efac394.png";